import React from "react";

const TAB_LABELS = {
  job_photos: { label: "Job Photos", icon: "fa-image" },
};

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <nav className="flex gap-4 mb-6" aria-label="Tabs">
      {tabs.map((tab) => {
        const isActive = activeTab === tab;
        const { label, icon } = TAB_LABELS[tab] || { label: tab };

        return (
          <button
            type="button"
            key={tab}
            onClick={() => onTabChange(tab)}
            className={`
              flex items-center gap-2 whitespace-nowrap px-4 py-3 font-medium text-sm rounded
              ${isActive ? "bg-brand text-white" : "bg-light"}
            `}
            aria-current={isActive ? "page" : undefined}
            data-testid={`category-${tab}`}
          >
            {icon && (
              <i className={`fa-regular ${icon}`} aria-hidden="true"></i>
            )}
            {label}
          </button>
        );
      })}
    </nav>
  );
};

export default TabNavigation;
